var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13 7.5V11H1V1H5.5C5.77614 1 6 0.776142 6 0.5C6 0.223858 5.77614 0 5.5 0H1C0.447716 0 0 0.447716 0 1V11C0 11.5523 0.447715 12 1 12H13C13.5523 12 14 11.5523 14 11V7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5ZM8 6C7.44772 6 7 5.55228 7 5V1C7 0.447715 7.44772 0 8 0H13C13.5523 0 14 0.447715 14 1V5C14 5.55228 13.5523 6 13 6H8ZM3 6.5C3 6.22386 3.22386 6 3.5 6H6C6.55228 6 7 6.44772 7 7V9.5C7 9.77614 6.77614 10 6.5 10C6.22386 10 6 9.77614 6 9.5V7.70703L3.62233 10.0847C3.45715 10.2499 3.16495 10.2255 2.96969 10.0302C2.77443 9.83497 2.75004 9.54278 2.91522 9.37759L5.29282 7H3.5C3.22386 7 3 6.77614 3 6.5Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ebb3c84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ebb3c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play_control/multi_window.vue
// module id = null
// module chunks = 